function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 25.903,
  cy: 26.515,
  rx: 21.5,
  ry: 18.5,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.033 49.99c-13.63.2-25.26-11.25-25.03-25.36C.223 11.31 10.913 0 25.023 0c13.79 0 25.32 11.11 24.96 25.78-.31 13.13-11.13 24.27-24.95 24.21zm-3.67-36.64c0-.05-4.64.22-6.94.54-1.72.24-3.41.67-5.1 1.11-1.02.26-1.6 1.4-1.42 2.52.12.74.97 1.84 2.08 1.72.55-.06 1.11-.15 1.65-.29 3.19-.79 6.44-1.11 9.71-1.11 2.83 0 5.67.18 8.44.8 2.01.45 4.03.95 5.98 1.61 1.47.5 2.84 1.29 4.25 1.95 1.03.49 2.27.1 2.84-.88.71-1.23.2-2.58-1.21-3.36-3.38-1.85-6.99-3.02-10.75-3.73-3.15-.59-6.33-.89-9.53-.88zm.05 8.59c-3.9-.01-7.14.45-10.32 1.34-1.24.35-1.85 1.5-1.36 2.61.41.93 1.38 1.29 2.49.95 2.36-.71 4.79-1.03 7.24-1.15 2.22-.11 4.42.08 6.62.41 2.64.39 5.19 1.06 7.63 2.13 1.21.53 2.35 1.22 3.56 1.76.97.44 2.26-.42 2.38-1.48.13-1.12-.54-1.7-1.39-2.18-2.97-1.7-6.16-2.85-9.49-3.56-2.63-.57-5.28-.86-7.36-.83zm-.21 8.22c0-.04-3.85.12-5.75.35-1.28.15-2.53.47-3.79.76-.74.17-1.24 1.02-1.07 1.67.23.83 1.08 1.31 1.89 1.13 1.12-.25 2.24-.47 3.37-.64 2.54-.38 5.09-.53 7.65-.3 1.42.13 2.85.36 4.24.67 2.34.52 4.52 1.45 6.58 2.67.58.34 1.25.27 1.68-.11.82-.72.73-1.8-.25-2.42-2.12-1.33-4.42-2.27-6.84-2.9-2.52-.67-5.09-1.02-7.71-.88z",
  fill: "#1CD760"
});

var SvgSourceSpotify = function SvgSourceSpotify(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceSpotify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_spotify.cbe079de.svg";
export { ForwardRef as ReactComponent };